import './ProgrammeDay.css';
import { ProgrammeEvent } from './index';
import formatDate from '../utils/formatDate';

export default function ProgrammeCard(day, options = {}) {
    const {
        showDayLabel = true,
        showFullDate = true,
        showTimes = true,
        showSpeakers = true,
        showAffiliations = true,
        showLocations = true,
        showDescriptions = true,
    } = options;

    const entries = day.entries ?? [];

    return `
        <section class="programme-day">

            <header class="programme-day__header">

                ${
                    showDayLabel
                        ? `
                            <h3 class="programme-day__title">
                                ${day.label}
                            </h3>
                        `
                        : ''
                }

                ${
                    showFullDate
                        ? `
                            <div class="programme-day__date">
                                ${formatDate(day.date)}
                            </div>
                        `
                        : ''
                }

            </header>

            ${
                entries.length === 0
                    ? `
                        <div class="schedule__empty">
                            Programme details will be available soon.
                        </div>
                    `
                    : `
                        <div class="programme-day__events">
                            ${entries
                                .map(entry => ProgrammeEvent({
                                    ...entry,
                                    showTimes,
                                    showSpeakers,
                                    showAffiliations,
                                    showLocations,
                                    showDescriptions,
                                }))
                                .join('')}
                        </div>
                    `
            }

        </section>
    `;
}
